import { lazyWithRetry as lazy } from './lazyWithRetry';
import { withProtected } from './withProtected';

export const product = [
	{
		path: '/account',
		Component: withProtected(lazy(() => import('../pages/Transactions'))),
		children: [
			{
				path: '/account/',
				Component: lazy(() => import('../pages/Transactions/Account')),
				handle: {
					key: 'pages.transactions.account.title'
				}
			},
			{
				path: '/account/:orderId',
				Component: lazy(() => import('../pages/Admin/OrderHistory/OrderDetails')),
				handle: {
					key: 'pages.transactions.account.title'
				}
			}
		]
	},
	{
		path: '/product-catalog',
		Component: withProtected(lazy(() => import('../pages/Product'))),
		children: [
			{
				path: '/product-catalog/',
				Component: lazy(() => import('../pages/Product/ProductCatalog')),
				handle: {
					key: 'pages.sharedWallet.title'
				}
			},
			{
				path: '/product-catalog/:userId/checkout',
				Component: lazy(() => import('../pages/Product/Checkout')),
				handle: {
					key: 'pages.sharedWallet.title'
				}
			}
		]
	}
];
